module.exports = __webpack_public_path__ + "img/h-hetong-type-icon1.3db5a8c8.png";